module.exports = __webpack_public_path__ + "img/login_page_image.9cc12bf4.jpeg";